import { render, staticRenderFns } from "./CompanyFeatureForm.vue?vue&type=template&id=30dbfde9"
import script from "./CompanyFeatureForm.vue?vue&type=script&lang=js"
export * from "./CompanyFeatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports